// extracted by mini-css-extract-plugin
export default {"revenueContent":"ReservedParkingPass_revenueContent__ZzRFk"};